module.exports = __webpack_public_path__ + "8921efc955cebe25745e549695bb5a44.svg";